import Component from "react-pure-render/component";
import React from "react";
import { addNotificationsForInvalidFields } from "../lib/validationWeb";
import Table from "./table.react.js";
import Modal from "../components/modal.react";
import InputWithError from "../components/inputWithError.react";

export default class FieldCategories extends Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    const {
      actions,
      fieldCategories: { fieldCategories: { meta: fieldCategoriesMeta } },
      notificationSystem
    } = this.props;

    actions
      .getFieldCategories(fieldCategoriesMeta)
      .then(({ error, payload }) => {
        if (error) {
          addNotificationsForInvalidFields(payload, notificationSystem);
        }
      });
  }

  componentDidUpdate(prevProps) {
    const {
      actions,
      fieldCategoriesTranslations: {
        forms: { createFieldCategoriesTranslation: { fields } }
      }
    } = this.props;
    const {
      fieldCategoriesTranslations: {
        forms: { createFieldCategoriesTranslation: { fields: prevFields } }
      }
    } = prevProps;

    if (fields.get("name") !== prevFields.get("name")) {
      actions.setFormField(
        "fieldCategoriesTranslations",
        "createFieldCategoriesTranslation",
        "placeholder",
        this.generateSlug(fields.get("name"))
      );
    }
  }

  generateSlug = name => {
    name = name.replace(/^\s+|\s+$/g, ""); // trim
    name = name.toLowerCase();

    const from = "àáäâąæãåāèéëêęėēìíïîòóöôóõœøōùúüûñçćčśßšłżźžń·/_,:;";
    const to = "aaaaaaaaaeeeeeeeiiiiooooooooouuuuncccssslzzzn------";
    for (var i = 0, l = from.length; i < l; i++) {
      name = name.replace(new RegExp(from.charAt(i), "g"), to.charAt(i));
    }

    name = name
      .replace(/[^a-z0-9 -]/g, "")
      .replace(/\s+/g, "-")
      .replace(/-+/g, "-");

    return name;
  };

  addCategory = () => {
    const {
      actions,
      notificationSystem,
      fieldCategoriesTranslations: {
        forms: { createFieldCategoriesTranslation: { fields } }
      },
      fieldCategories: { fieldCategories: { meta: fieldCategoriesMeta } },
      locales: { locales: { defaultLocale } }
    } = this.props;
    let data = fields.toJS();
    data.locale = defaultLocale;
    data.fieldCategoryUID = null;
    actions
      .createFieldCategoriesTranslation(data)
      .then(({ error, payload }) => {
        if (error) {
          addNotificationsForInvalidFields(payload, notificationSystem);
        } else {
          actions
            .getFieldCategories(fieldCategoriesMeta)
            .then(({ error, payload }) => {
              if (error) {
                addNotificationsForInvalidFields(payload, notificationSystem);
              }
            });
          actions.setShouldMenuLeftRerender(true);
        }
      });
    actions.setIsAddFieldCategoryTranslationModalVisible(false);
  };

  openAddFieldCategoryModal = () => {
    const { actions } = this.props;
    actions.setIsAddFieldCategoryTranslationModalVisible(true);
  };

  closeAddFieldCategoryModal = () => {
    const { actions } = this.props;
    actions.setIsAddFieldCategoryTranslationModalVisible(false);
  };

  render() {
    const {
      actions,
      fieldCategoriesTranslations: {
        forms: { createFieldCategoriesTranslation: form }
      },
      fieldCategories,
      msg: { fieldCategoryTranslation: msg },
      history,
      notificationSystem
    } = this.props;

    const isAddModalVisible = true;

    const addFieldCategoryFormProps = {
      feature: "fieldCategoriesTranslations",
      actions: actions,
      form: form,
      formName: "createFieldCategoriesTranslation",
      msg: msg.forms.createFieldCategoryTranslation,
      validateFormField: actions.validateFormFieldFieldCategoriesTranslations
    };

    return (
      <div className="islogged-page">
        <div className="row middle-xs">
          <h2 className="col-xs-8">Ustawienia</h2>
          <div className="col-xs-4">
            <button className="info" onClick={this.openAddFieldCategoryModal}>
              dodaj kategorię
            </button>
          </div>
          <div className="col-xs-12">
            <div className="box-wrapper">
              <div className="title">Kategorie</div>
              <div className="content-wrapper">
                <Table
                  history={history}
                  fieldCategories={fieldCategories}
                  tableWidth={1000}
                  tableHeight={300}
                  actions={actions}
                  notificationSystem={notificationSystem}
                />
              </div>
            </div>
          </div>
        </div>
        {form.isAddModalVisible && (
          <Modal
            closeModalAction={this.closeAddFieldCategoryModal}
            enterAction={this.addCategory}
            handleKeyDownEvent={true}
          >
            <div className="row">
              <h3 className="col-xs-12">Dodaj kategorię</h3>
              <div className="col-xs-12">
                <InputWithError
                  placeholder="Nazwa kategorii"
                  field={["name"]}
                  {...addFieldCategoryFormProps}
                />
              </div>
              <div className="col-xs-12">
                <InputWithError
                  placeholder="Opis kategorii"
                  field={["description"]}
                  {...addFieldCategoryFormProps}
                />
              </div>
              <div className="col-xs-12">
                <InputWithError
                  placeholder="Placeholder"
                  field={["placeholder"]}
                  {...addFieldCategoryFormProps}
                />
              </div>
              <div className="col-xs-12">
                <button className="info" onClick={this.addCategory}>
                  Dodaj kategorię
                </button>
              </div>
            </div>
          </Modal>
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/browser/fieldCategories/fieldCategories.react.js